module.exports = __webpack_public_path__ + "img/trash_white.59e0a179.svg";